export const testimonials = [
  {
    id: 1,
    name: 'João Victor',
    text: 'Melhor barbearia de Fortaleza. O atendimento é impecável e o ambiente é de outro nível. Saio de lá me sentindo um novo homem. Recomendo de olhos fechados.',
    rating: 5,
    date: '2026-06-15',
  },
  {
    id: 2,
    name: 'Rafael Almeida',
    text: 'Finalmente encontrei uma barbearia que entende o que o homem moderno busca: tradição, técnica e um ambiente verdadeiramente masculino. Virou minha segunda casa.',
    rating: 5,
    date: '2026-06-10',
  },
  {
    id: 3,
    name: 'Pedro Henrique',
    text: 'Levei meu filho pela primeira vez e a experiência foi incrível. O nome faz todo sentido. Tradição passada de pai para filho em cada detalhe.',
    rating: 5,
    date: '2026-05-28',
  },
  {
    id: 4,
    name: 'Marcos Paulo',
    text: 'O cuidado com cada detalhe é impressionante. Desde a recepção até o acabamento final, tudo é pensado para proporcionar uma experiência premium.',
    rating: 5,
    date: '2026-05-20',
  },
  {
    id: 5,
    name: 'Thiago Santos',
    text: 'Ambiente sofisticado, barbeiros extremamente qualificados e o melhor café de Fortaleza. Vale cada centavo e cada minuto.',
    rating: 5,
    date: '2026-05-12',
  },
  {
    id: 6,
    name: 'Carlos Eduardo',
    text: 'Sou cliente há 2 anos e nunca pensei em trocar. A consistência na qualidade é absurda. Ricardo e equipe são verdadeiros artistas da barbearia.',
    rating: 5,
    date: '2026-04-30',
  },
];